import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {Tur} from '../enum/tur.enum';

@Injectable()
export class PacketSyncService {
  
    constructor(private https: HttpClient, private  authService: AuthenticationService) { }
  
    updateMarkaDatabase() {
        const apiURL = AppConstants.API_ENDPOINT_SPRING + 'packetsync/updateAll/';
        return this.https.get<String>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
    }

    isOngoingOperationExists() {
        const apiURL = AppConstants.API_ENDPOINT_SPRING + 'packetsync/';
        return this.https.get<String>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
    }
  
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/packetsync.service.ts